// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"textForm-module--wrapper--Puny1"};